module.exports = __webpack_public_path__ + "static/Logo-ae19d994a723738cebdf5fce007cb0f4.svg";